import React, { useState } from "react";
import LockIcon from "../../common/images-new/lock-gray-icon.svg"
import { Card } from "../../pages/Theme";
import Toggle from "../Button/Toggle";
import GoogleApiWrapper from "./ReflectionLocationDashboardMapGoogle";
// import MapGoogle from "./MapGoogle";
import { Link } from "react-router-dom/cjs/react-router-dom";

const Map = (data) => {
    const [show, setShow] = useState(true)
    return (
        <Card className={`${show === true ? 'block' : 'hidden'} 
                    flex flex-col bg-white w-full relative justify-self-center absolute md:top-0 md:rounded-lg`}
        >
            <Link to={"/map"}>
                <div className="justify-center cursor-pointer pt-5">
                    <GoogleApiWrapper locations={data}/>
                </div>
            </Link>
        </Card>
    )
}

export default Map;
